import React from 'react'
import { DAYS_OF_WEEK } from '../../utils/scheduleRepeat'
import MonthDayTimeFields from './MonthDayTimeFields'

const inputClass =
  'w-full bg-white dark:bg-secondaryDark border dark:border-border-dark dark:text-white rounded-md py-2 font-light px-3 text-sm focus:outline-none focus:ring-2 focus:ring-yellowcolor focus:border-transparent placeholder-gray-400'

const errorInputClass = (hasError) =>
  `${inputClass} ${hasError ? 'border-red-500' : 'border-gray-200 dark:border-border-dark'}`

const ScheduleRepeatFields = ({
  repeat,
  onRepeatChange,
  repeatOptions,
  date,
  onDateChange,
  day,
  onDayChange,
  months = [],
  onMonthsChange,
  dayOfMonth,
  onDayOfMonthChange,
  time,
  onTimeChange,
  errors = {},
}) => {
  return (
    <div className="space-y-4">
      <div className="flex flex-wrap gap-4 items-center mb-2">
        <span className="text-sm font-medium dark:text-white">Repeat</span>
        {repeatOptions.map((opt) => (
          <label key={opt.value} className="flex items-center gap-1 text-sm font-medium">
            <input
              type="radio"
              className="form-radio text-yellowcolor focus:ring-yellowcolor"
              checked={repeat === opt.value}
              onChange={() => onRepeatChange(opt.value)}
            />
            <span className={repeat === opt.value ? 'text-yellowcolor' : 'dark:text-white'}>
              {opt.label}
            </span>
          </label>
        ))}
      </div>

      {repeat === 'weekly' && (
        <div className="flex flex-col sm:flex-row gap-4">
          <div className="flex-1">
            <label className="block text-sm font-medium mb-1 dark:text-white">Day Selection</label>
            <select
              className={errorInputClass(errors.day)}
              value={day}
              onChange={(e) => onDayChange(e.target.value)}
              name="day"
            >
              {DAYS_OF_WEEK.map((d) => (
                <option key={d} value={d}>{d}</option>
              ))}
            </select>
            {errors.day && <p className="text-xs text-red-500 mt-1">{errors.day}</p>}
          </div>
          <div className="flex-1">
            <label className="block text-sm font-medium mb-1 dark:text-white">Time</label>
            <input
              type="time"
              className={errorInputClass(errors.time)}
              value={time}
              onChange={(e) => onTimeChange(e.target.value)}
              name="time"
            />
            {errors.time && <p className="text-xs text-red-500 mt-1">{errors.time}</p>}
          </div>
        </div>
      )}

      {repeat === 'monthly' && (
        <MonthDayTimeFields
          months={months}
          onMonthsChange={onMonthsChange}
          dayOfMonth={dayOfMonth}
          onDayOfMonthChange={onDayOfMonthChange}
          time={time}
          onTimeChange={onTimeChange}
          errors={errors}
          multiMonth
        />
      )}

      {repeat === 'one_time' && (
        <MonthDayTimeFields
          months={months}
          onMonthsChange={onMonthsChange}
          dayOfMonth={dayOfMonth}
          onDayOfMonthChange={onDayOfMonthChange}
          time={time}
          onTimeChange={onTimeChange}
          errors={errors}
          multiMonth={false}
        />
      )}

      {repeat === 'daily' && (
        <div className="flex flex-col sm:flex-row gap-4">
          <div className="flex-1 sm:max-w-xs">
            <label className="block text-sm font-medium mb-1 dark:text-white">Time</label>
            <input
              type="time"
              className={errorInputClass(errors.time)}
              value={time}
              onChange={(e) => onTimeChange(e.target.value)}
              name="time"
            />
            {errors.time && <p className="text-xs text-red-500 mt-1">{errors.time}</p>}
          </div>
        </div>
      )}

      {errors.scheduleFuture && (
        <p id="schedule-repeat-error" className="text-xs text-red-500">{errors.scheduleFuture}</p>
      )}
    </div>
  )
}

export default ScheduleRepeatFields
